import { getFeatureData } from "modules/organizations/OrganizationsState";

export const getSurgicalToteTrackingSolutionId = (state) => {
  const featureData = getFeatureData(state);
  return Array.isArray(featureData) && featureData.length > 0
    ? featureData[0].solution ?? null
    : null;
};
